/* eslint-disable import/prefer-default-export */
import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';
import {
    CodeBlock,
    BlockType,
    SettingType,
    Define,
    ValidationMessageType,
    ValidationMessage,
    SettingState,
    IOLinesMode,
    Setting,
    TibboDataType,
} from '@appblocks/codegeneration/types';
import PlatformUtils from '@appblocks/platforms/PlatformUtils';
import Tibbits from '@appblocks/codegeneration/Tibbits';
import BaseTibbit from '@appblocks/codegeneration/Tibbits/_BaseTibbit';

export const getCodeBlocks = (feature: BaseTibbit): CodeBlock[] => {
    const blocks: Array<CodeBlock> = [];

    const currentSocket = Number(feature.getSettingValue('SOCKET'));
    const prevSocket = (currentSocket - 1).toString();
    const TEMP_NAME = feature.getSettingValue('TEMP_NAME');
    const HUM_NAME = feature.getSettingValue('HUM_NAME');
    const NAME = `${TEMP_NAME}_${HUM_NAME}`;
    const { project } = feature;
    const ID = feature.getID();
    const connectedSocket = (Number(feature.getSettingValue('SOCKET')) - 1).toString();

    blocks.push({
        location: 'boot',
        blockType: BlockType.CODE,
        template: `
'Tibbit 00_3 with tibbit 30
tbt30_init("${NAME}",NO,${NAME}_CLK,${NAME}_DATA,${NAME}_CHANNEL_NUM)`,
    });

    blocks.push({
        location: 'GLOBAL_DECLARATIONS',
        blockType: BlockType.CODE,
        template: `
declare ${NAME}_CHANNEL_NUM as byte
            `,
    });

    blocks.push({
        location: 'GLOBAL_DIMS',
        blockType: BlockType.CODE,
        template: `
dim ${NAME}_CHANNEL_NUM as byte
            `,
    });

    blocks.push({
        location: `var_${TEMP_NAME}_update`,
        blockType: BlockType.CODE,
        template: `
    dim tmp_${HUM_NAME},tmp_${TEMP_NAME} as float
    tbt30_get_pc(tmp_${HUM_NAME}, tmp_${TEMP_NAME}, ${NAME}_CHANNEL_NUM)
    var_${HUM_NAME}_update_completed(tmp_${HUM_NAME})
    var_${TEMP_NAME}_update_completed(tmp_${TEMP_NAME})`,
    });

    blocks.push({
        location: 'GLOBAL_CONSTS',
        blockType: BlockType.CODE,
        template: `
const ${NAME}_CLK = ${Tibbits.getSocketPins(connectedSocket, feature.project.device.id)[0]}
const ${NAME}_DATA = ${Tibbits.getSocketPins(connectedSocket, feature.project.device.id)[1]}`,
    });

    return blocks;
};
